import React from "react";
import { Box, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#000",
        color: "#fff",
        overflow: "hidden",
        py: { xs: 4, md: 5 },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(128,0,255,0.25) 0%, rgba(0,0,0,0.9) 100%)",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          maxWidth: "1200px",
          mx: "auto",
          px: { xs: 3, md: 6 },
          textAlign: "center",
        }}
      >
        <Typography sx={{ fontSize: { xs: ".95rem", md: "1rem" } }}>
          © 2026 Todos los derechos reservados <strong>DobleDx</strong> | Desarrollado por{" "}
          <Box
            component="a"
            href="https://devzone-ec.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: "none",
              fontWeight: 700,
              display: "inline-flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <Box component="span" sx={{ color: "#03C4FF" }}>
              DEV
            </Box>
            <Box component="span" sx={{ color: "#FFFFFF" }}>
              Z
            </Box>
            <Box component="span" sx={{ color: "#FF7A00" }}>
              ONE
            </Box>
          </Box>
        </Typography>
      </Box>
    </Box>
  );
}
